import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (consent === 'accepted') {
      loadExternalScripts();
    } else if (!consent) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const loadExternalScripts = () => {
    // 1. Load AdSense
    if (!document.getElementById('adsense-script')) {
      const script = document.createElement('script');
      script.id = 'adsense-script';
      script.async = true;
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-XXXXXXXXXXXXXXXX"; // Replace with real ID
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);
    }

    // 2. Opt-in PostHog tracking if it exists
    if (window.posthog) {
      window.posthog.opt_in_capturing();
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    loadExternalScripts();
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    if (window.posthog) {
      window.posthog.opt_out_capturing();
    }
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:max-w-md z-50"
        >
          <div className="bg-white/80 backdrop-blur-xl border border-[#E4EAF0] rounded-2xl shadow-2xl p-6 overflow-hidden relative">
            {/* Subtle gradient background element */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#0F3D5C]/5 rounded-full blur-3xl pointer-events-none" />
            
            <div className="flex items-start gap-4">
              <div className="bg-[#EEF4F8] p-3 rounded-xl flex-shrink-0">
                <Cookie className="w-6 h-6 text-[#0F3D5C]" />
              </div>
              
              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0E1621] mb-1 font-syne">
                  On peut vous piquer un cookie ?
                </h3>
                <p className="text-sm text-[#4A5E73] leading-relaxed mb-6 font-dm-sans">
                  Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et assurer la sécurité de notre plateforme.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={handleAccept}
                    className="btn-primary flex-1 py-2.5"
                  >
                    Tout accepter
                  </button>
                  <button
                    onClick={handleDecline}
                    className="btn-secondary flex-1 py-2.5"
                  >
                    Refuser
                  </button>
                </div>
              </div>

              <button 
                onClick={() => setIsVisible(false)}
                className="text-[#9EB3C4] hover:text-[#0E1621] transition-colors p-1"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
